<template>
    <form action="" @submit.prevent="update">
        <div class="headline-sm">
            פרטי לקוח
        </div>
        <div class="form-inline">
            <div class="form-group">
                <input v-model="first_name" type="text" id="firstName">
                <label for="firstName">שם פרטי
                    <span class="required-star">*</span>
                </label>
            </div>
            <div class="form-group">
                <input v-model="last_name" type="text" id="lastName">
                <label for="lastName">שם משפחה
                    <span class="required-star">*</span>
                </label>
            </div>
        </div>
        <div class="form-inline">
            <div class="form-group">
                <input v-model="email" type="text" id="email">
                <label for="email">דואר אלקטרוני
                    <span class="required-star">*</span>
                </label>
            </div>
            <div class="form-group">
                <input v-model="phone" type="text" id="phone">
                <label for="phone">טלפון
                    <span class="required-star">*</span>
                </label>
            </div>
        </div>
        <div class="headline-sm">חשבונית על שם</div>
        <div class="form-inline">
            <div class="form-group">
                <input v-model="company_name" type="text" placeholder="שם פרטי/שם חברה" id="companyName">
            </div>
            <div class="form-group">
                <input v-model="company_code" type="text" placeholder="ע.מ/.ח.פ." id="companyCode">
            </div>
        </div>
        <div class="headline-sm">שינוי סיסמה</div>
        <div class="form-inline">
            <div class="form-group">
                <input v-model="password" type="password" placeholder="סיסמה" id="newPassword">
            </div>
            <div class="form-group">
                <input v-model="password_confirmation" type="password" placeholder="אימות סיסמה" id="repeatNewPassword">
            </div>
        </div>
        <div class="form-check">
            <input v-model="mailings" type="checkbox" id="mailings" name="checkbox-group">
            <label for="mailings">אני מסכים/ה לקבל את הניוזלטר</label>
        </div>
        <button type="submit" class="btn-black">שמור שינויים</button>
    </form>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "PersonalInfo",
        data() {
            return {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                company_name: '',
                company_code: '',
                password: '',
                password_confirmation: '',
                mailings: '',
                errors: [],
            }
        },
        beforeMount() {
            this.getPersonal()
        },
        methods: {
            getPersonal() {
                axios.get(route('client.customer.get-personal'))
                    .then((resp) => {
                        this.id = resp.data.id
                        this.personal = resp.data.personal
                        this.first_name = resp.data.personal.first_name
                        this.last_name = resp.data.personal.last_name
                        this.email = resp.data.personal.email
                        this.phone = resp.data.personal.phone
                        this.company_name = resp.data.personal.company_name
                        this.company_code = resp.data.personal.company_code
                        this.mailings = resp.data.personal.mailings
                    })
            },
            update() {
                axios.post(route('client.customer.update-personal'), {
                    id: this.id,
                    first_name: this.first_name,
                    last_name: this.last_name,
                    email: this.email,
                    phone: this.phone,
                    company_name: this.company_name,
                    company_code: this.company_code,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                    mailings: this.mailings,
                })
                    .then((response) => {
                        this.updated = true
                    })
            },
        }
    }
</script>

<style scoped>

</style>
